import React, { useState ,useEffect} from "react";
import { Sidebar, MobileMenu, Footer, Navbars, AdSense } from "components";
import { clearLocalStorage } from "utils/common";
import { useDispatch, useSelector } from "react-redux";
import Loading from "components/Loading";
import ChatBot from "components/ChatBot";
import { getSiteSettings } from "components/Navbars/navbarsSlice";

function Layout({ children }) {
  const dispatch = useDispatch();
  const [hasLogin, setHasLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { isAuth } = useSelector((state) => state.user);
  const { isRevoke } = useSelector((state) => state.top);

  useEffect(() => {
    const fetchSettings = async () => {
      await dispatch(getSiteSettings());
      setIsLoading(false);
    };
    
    fetchSettings();
  }, [dispatch]);

  useEffect(() => {
    if (isAuth !== null) {
      setHasLogin(isAuth);
    }
  }, [isAuth]);

  useEffect(() => {
    if (isRevoke === true) {
      clearLocalStorage();
      setHasLogin(false);
    }
  }, [isRevoke]);

  return (
    <div>
      <Navbars />
      <Loading isAuth={isAuth} />
      <ChatBot />
      {
        (isLoading || isAuth === null) ? null :
        <>
          {hasLogin ? (
            <section
              className={`clap container-fluid px-0 mx-md-auto ${
                hasLogin ? "section-auth" : ""
              }`}
            >
              <div className="d-flex px-0 px-md-4">
                <Sidebar />
                {children}
              </div>
            </section>
          ) : (
            <section>{children}</section>
          )}
          <section style={{minHeight:'auto'}} >
          <AdSense />
          </section>
          <Footer />
          {hasLogin && <MobileMenu />}
        </>
      }
    </div>
  );
}

export default Layout;
